<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <div class="iq-card-body ">
      <b-form @submit.prevent="handleSubmit(submit)" ref="ServicesForm">
        <div class="iq-card-header ">
          <div class="iq-header-title d-flex justify-content-between">
            <h4 class="card-title">
              {{ pageTitle }}
            </h4>
            <div v-if="pageTitle === 'Edit Service'">
              <b-button
                variant="primary"
                @click="$emit('showAddChanged', !showAdd)"
                ><i class="ion-plus"></i
              ></b-button>
            </div>
          </div>
        </div>

        <FormGenerator
          :Fields="fields"
          :model="formData"
          :options="options"
          globalClass="w-100"
        />

        <div>
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          <button v-else type="submit" class="btn btn-primary">
            {{ buttonName }}
          </button>
        </div>
      </b-form>
    </div>
  </ValidationObserver>
</template>
<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { Fields, options, models } from "./form_fields";
import { getServiceData } from "@/API/ServicesAPIs";

export default {
  name: "Form",
  components: {
    FormGenerator
  },
  props: [
    "id",
    "pageTitle",
    "buttonName",
    "isInList",
    "model",
    "isCreateMode",
    "loading",
    "showAdd"
  ],
  data() {
    return {
      formData: JSON.parse(JSON.stringify(models)),
      options,
      fields: Fields,
      emptyModel: null
    };
  },
  async created() {
    await this.loadData();
  },
  async mounted() {
    this.emptyModel = models;
  },
  watch: {
    async id(val) {
      if (this.id) this.formData = await getServiceData(val);
    },
    model: {
      deep: true,
      handler(value) {
        this.formData = JSON.parse(JSON.stringify(value));
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit", this.formData);
    },
    resetForm() {
      if (this.emptyModel) {
        this.formData = JSON.parse(JSON.stringify(this.emptyModel));
        this.$refs.validationObserver && this.$refs.validationObserver.reset();
      } else {
        console.error("emptyModel is not defined");
      }
    },
    async loadData() {
      if (!this.id) this.id = this.$route.params.id;
      if (this.id) this.formData = await getServiceData(this.id);
      if (this.model) this.formData = { ...this.model };
      if (this.createForm) {
      }
    }
  }
};
</script>
<style scoped></style>
